// This version is used for Reviews GraphQL schema generation (`pnpm codegen`)
// and is sent in the 'X-Api-Version' header for API requests.
export const schemaVersion = '20250521'
